import type { ModelsResolver } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { postgresToJsonArray } from "@/utils/utils-dependent";
import type { Deviation_Survey_Insert_Input } from "gql/api";

const { info: logInfo } = useLogger("DEVIATION_SURVEYS_RESOLVER");

export default {
  optimistic: {
    insert_deviation_survey(vars, cache, info) {
      logInfo("Optimistic", { vars, cache, info });
      const affectedRows = vars.objects.length;

      return {
        affected_rows: affectedRows,
        __typename: "deviation_survey_mutation_response",
        returning: vars.objects.map(obj => ({
          __typename: "deviation_survey",
          ...(obj as Omit<Deviation_Survey_Insert_Input, "user">),
          entry_rows: postgresToJsonArray(
            obj.entry_rows as unknown as string,
            true
          ),
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          deleted_at: null
        }))
      };
    }
  }
} as ModelsResolver;
